import {
    buildMyIdOAuthStringACME,
    getLastAttemptedRef,
    removeLastAttemptedRef,
} from '../utils/auth-utils';

// Auth Service
angular.module('archie.core').factory('AuthService', AuthService);

/**
 *
 * @param HttpWrapperService
 * @param UserService
 * @param snowplowService
 * @param $q
 * @param $window
 * @returns {{isDisabled: isDisabled, setDisabled: setDisabled, setAuthenticated: setAuthenticated, isAuthenticated: isAuthenticated, tokenCheck: tokenCheck, logout: logout, login: login}}
 * @constructor
 */
function AuthService(
    HttpWrapperService: any,
    UserService: any,
    snowplowUtilsService: any,
    $q: angular.IQService,
    $window: angular.IWindowService,
    $filter: angular.IFilterFunction
) {
    let authenticated = false;
    const appConfig = window.appConfig;
    let disabled = appConfig.disableAuth; // constant defined via config

    return {
        isDisabled: isDisabled,
        setDisabled: setDisabled,
        setAuthenticated: setAuthenticated,
        isAuthenticated: isAuthenticated,
        tokenCheck: tokenCheck,
        logout: logout,
        login: login,
        appendUrl: appendUrl,
    };

    function setDisabled(value: boolean) {
        disabled = value;
    }

    function isDisabled(): boolean {
        return disabled;
    }

    function setAuthenticated(value: boolean) {
        authenticated = value;
    }

    function isAuthenticated(): boolean {
        // if authentication is disabled via config, always return true.
        return isDisabled() ? true : authenticated;
    }

    function tokenCheck(): ng.IPromise<void> {
        return HttpWrapperService.get('/login/user').then(
            function (response) {
                UserService.setUsername(response.data[appConfig.userKey]);
                UserService.setEmail(response.data[appConfig.emailKey]);
                setAuthenticated(true);
                const uid = snowplowUtilsService.getUserId(response.data);
                snowplowUtilsService.setUserId(uid);
                snowplowUtilsService.trackUnknownUser(response.data);
            },
            function (rejection) {
                setAuthenticated(false);
                return $q.reject(rejection);
            }
        );
    }

    function logout() {
        UserService.removeProfile(); //clear stored username, token
        setAuthenticated(false); //remove ui from DOM
        $window.location.href = '#/myidoptions';
        removeLastAttemptedRef();
    }

    function login() {
        //save current url so return here after login complete
        const loginURL = buildMyIdOAuthStringACME(
            appConfig.discoveryServiceURL,
            appConfig.redirectUri,
            getLastAttemptedRef()
        );
        $window.location.href = loginURL;
    }

    /**
     *
     * @param url {string} a url to be appended with auth param
     * @returns {string} url appended with auth param containing token
     */
    function appendUrl(url: string): string {
        if (!disabled) {
            url += $filter('paramDelimiter')(url);
            url += 'auth=' + encodeURIComponent('Bearer ' + UserService.profile.token);
        }
        return url;
    }

    function generateNonce(): string {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (Math.random() * 16) | 0,
                v = c == 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    }
}
